import { StructureBuilder } from "sanity/structure";

export default (S: StructureBuilder) =>
  S.listItem()
    .title("Shared Section")
    .schemaType("sharedSection")
    .child(S.documentTypeList("sharedSection"));
